module.exports = __webpack_public_path__ + "static/media/domaintransfer2.24dcae7c.png";